<template>
  <form @submit.prevent="validar">
    <h6 class="text-primary linea2">Activos</h6>
    <div class="alert alert-secondary fade show" :class="errors.has('Activos') && 'alert-danger'" role="alert"
         v-if="validacion.activos>0">
      Debes completar mínimo&nbsp;<b>{{ validacion.activos }}</b>&nbsp;Activo<span v-if="validacion.activos>1">s</span>
    </div>
    <div class="pb-2">
      <activos
          :sync="cargandoLst"
          :previos="tipo.form===1 ? previos.elements2 : previos.elements13"
          :lista="lstTipoActivo"
          name="Activos"
          v-model="datos.activos"
          v-validate="{required:validacion.activos>0,lst:validacion.activos}"
          :lst-institucion="lstInstitucion"
          :lst-tipo-inmueble="lstTipoInmueble"
          :lst-marca="lstMarca"
          v-on:marca="consultaModelo" :lst-modelo="lstModelo"
          :tipo="tipo"
      ></activos>
    </div>

    <h6 class="text-primary linea2">Pasivos</h6>
    <div class="alert alert-secondary fade show" :class="errors.has('Pasivos') && 'alert-danger'" role="alert"
         v-if="validacion.pasivos>0">
      Debes completar mínimo&nbsp;<b>{{ validacion.pasivos }}</b>&nbsp;Pasivo<span v-if="validacion.pasivos>1">s</span>
    </div>
    <div class="pb-2">
      <pasivos
          name="Pasivos"
          v-validate="{required:validacion.pasivos>0,lst:validacion.pasivos}"
          v-model="datos.pasivos"
          :sync="cargandoLst"
          :previos="tipo.form===1 ? previos.elements8 : previos.elements16"
          :lst-tipo-pasivo="lstTiposPasivo"
          :tipo="tipo"
      ></pasivos>
    </div>

    <h6 class="text-primary linea2">Ingresos</h6>
    <div class="alert alert-secondary fade show" :class="errors.has('Ingresos') && 'alert-danger'" role="alert"
         v-if="validacion.ingresos>0">
      Debes completar mínimo&nbsp;<b>{{ validacion.ingresos }}</b>&nbsp;Ingreso<span
        v-if="validacion.ingresos>1">s</span>
    </div>
    <div class="pb-2">
      <ingresos
          name="Ingresos"
          v-validate="{required:validacion.ingresos>0,lst:validacion.ingresos}"
          v-model="datos.ingresos"
          :sync="cargandoLst"
          :previos="tipo.form===1 ? previos.elements3 : previos.elements14"
          :lst-tipo-ingreso="lstTiposIngreso"
          :tipo="tipo"
      ></ingresos>
    </div>

    <h6 class="text-primary linea2">Gastos</h6>
    <div class="alert alert-secondary fade show" :class="errors.has('Gastos') && 'alert-danger'" role="alert"
         v-if="validacion.gastos>0">
      Debes completar mínimo&nbsp;<b>{{ validacion.gastos }}</b>&nbsp;Gasto<span v-if="validacion.gastos>1">s</span>
    </div>
    <div class="pb-2">
      <gastos
          name="Gastos"
          v-validate="{required:validacion.gastos>0,lst:validacion.gastos}"
          v-model="datos.gastos"
          :sync="cargandoLst"
          :previos="tipo.form===1 ? previos.elements4 : previos.elements15"
          :lst-tipo-gasto="lstTiposGasto"
          :tipo="tipo"
      ></gastos>
    </div>
    <div class="col-12 col-md-12 p-1">
      <button type="submit" class="btn btn-primary btn-elevate btn-pill btn-block"
              :class="cargando ? 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light' : ''"
              :disabled="cargando">Guardar
      </button>
    </div>
  </form>
</template>

<script>
import constantes from "../../constantes";
import {catalogos} from "../../servicios";
import activos from "./activos";
import pasivos from "./pasivos";
import ingresos from "./ingresos";
import gastos from "./gastos";
import {persona} from "../../servicios";
import _ from 'lodash';

export default {
  name: "situacionFinanciera",
  data: () => ({
    lstTipoActivo: [],
    lstTiposPasivo: [],
    lstTiposIngreso: [],
    lstTiposGasto: [],
    lstInstitucion: [],
    lstTipoInmueble: [],
    lstMarca: [],
    lstModelo: [],
    datos: {
      activos: [],
      pasivos: [],
      ingresos: [],
      gastos: [],
    },
    listado: constantes.Constantes.tiposActivos,
    cargandoLst: false,
    cargando: false,
  }),
  components: {
    activos,
    pasivos,
    ingresos,
    gastos
  },
  props: {
    validacion: {
      type: Object,
      default: () => ({
        activos: 1,
        pasivos: 0,
        ingresos: 1,
        gastos: 1
      })
    },
    conyugue: {
      type: Object,
      default: () => ({
        id: null,
      })
    },
    formulario: {
      type: Object,
      required: true
    },
    tipo: {
      type: Object,
      required: true
    },
    previos: {
      type: Object
    },
  },
  methods: {
    validar: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.cargando = true;
          this.enviarDatos();
        } else {
          this.$toast.show(`Completa el formulario ` + this.formulario.id + " " + this.tipo.titulo);
          setTimeout(() => {
            let container = this.$el.querySelector('.alert-danger');
            container.scrollIntoView();
          }, 100);
        }
      });
    },
    async catalogoTipos() {
      const [
        tipoActivo,
        tipoPasivo,
        tipoIngreso,
        tipoGasto,
        entidadesBancarias,
        tipoInmuebles,
        marca
      ] = await catalogos.lstSituacionFinanciera();
      this.lstTipoActivo = tipoActivo.data;
      this.lstTiposPasivo = tipoPasivo.data;
      this.lstTiposIngreso = tipoIngreso.data;
      this.lstTiposGasto = tipoGasto.data;
      this.lstInstitucion = entidadesBancarias.data;
      this.lstTipoInmueble = tipoInmuebles.data;
      this.lstMarca = marca.data;
      this.cargandoLst = true;
    },
    consultaModelo(v) {
      catalogos.modelos(v).then(r => r.data).then(response => {
        this.lstModelo = response;
        this.lstModelo = this.lstModelo.filter(x => !x.dt1.toLowerCase().includes(constantes.Constantes.porDefinir) && !x.dt1.toLowerCase().includes(constantes.Constantes.AvaluosMecanicos))
      });
    },
    enviarDatos: _.debounce(function () {
      if (this.tipo.form === 2)
        if (!this.conyugue.id) {
          this.$toast.show(`Completa el formulario del Cónyuge Datos Personales`);
          this.cargando = false;
          return 0;
        }
      persona.actualizacionActivos(this.datos.activos, this.tipo.form, this.conyugue.id).then(() => {
        persona.actualizacionPasivos(this.datos.pasivos, this.tipo.form, this.conyugue.id).then(() => {
          persona.actualizacionIngresos(this.datos.ingresos, this.tipo.form, this.conyugue.id).then(() => {
            persona.actualizacionGastos(this.datos.gastos, this.tipo.form, this.conyugue.id).then(() => {
              this.datos.complete = true;
              this.cargando = false;
              this.$emit('input', this.datos);
            }).catch(() => {
              this.cargando = false;
            });
          }).catch(() => {
            this.cargando = false;
          });
        }).catch(() => {
          this.cargando = false;
        });
      });
    }, 2000),
  },
  created() {
    this.catalogoTipos();
  },
}
</script>

<style scoped>

</style>
